/* eslint-disable @typescript-eslint/no-magic-numbers */
export var KicadPadShape;
(function (KicadPadShape) {
    KicadPadShape["circle"] = "circle";
    KicadPadShape["rectangle"] = "rect";
    KicadPadShape["oval"] = "oval";
    KicadPadShape["trapezoid"] = "trapezoid";
    KicadPadShape["roundRect"] = "roundrect";
    KicadPadShape["custom"] = "custom";
})(KicadPadShape || (KicadPadShape = {}));
export var KicadPadType;
(function (KicadPadType) {
    KicadPadType["thruHole"] = "thru_hole";
    KicadPadType["surfaceMountDevice"] = "smd";
    KicadPadType["connect"] = "connect";
    KicadPadType["nonPlatedThruHole"] = "np_thru_hole";
})(KicadPadType || (KicadPadType = {}));
const moduleTemplate = {
    name: "",
    layer: "F.Cu",
    currPadIndex: 1,
    pos: {
        x: 0,
        y: 0,
        r: 0,
        rdeg: 0,
    },
    at: {
        x: 0,
        y: 0,
        unlocked: false,
        angle: 0,
    },
};
export const KicadLayerDesignators = [
    "In2.Cu", // Inner copper layer 2
    "In3.Cu", // Inner copper layer 3
    "In4.Cu", // Inner copper layer 4
    "In5.Cu", // Inner copper layer 5
    "In6.Cu", // Inner copper layer 6
    "In7.Cu", // Inner copper layer 7
    "In8.Cu", // Inner copper layer 8
    "In1.Cu", // Inner copper layer 1
    "In9.Cu", // Inner copper layer 9
    "In10.Cu", // Inner copper layer 10
    "In11.Cu", // Inner copper layer 11
    "In12.Cu", // Inner copper layer 12
    "In13.Cu", // Inner copper layer 13
    "In14.Cu", // Inner copper layer 14
    "In15.Cu", // Inner copper layer 15
    "In16.Cu", // Inner copper layer 16
    "In17.Cu", // Inner copper layer 17
    "In18.Cu", // Inner copper layer 18
    "In19.Cu", // Inner copper layer 19
    "In20.Cu", // Inner copper layer 20
    "In21.Cu", // Inner copper layer 21
    "In22.Cu", // Inner copper layer 22
    "In23.Cu", // Inner copper layer 23
    "In24.Cu", // Inner copper layer 24
    "In25.Cu", // Inner copper layer 25
    "In26.Cu", // Inner copper layer 26
    "In27.Cu", // Inner copper layer 27
    "In28.Cu", // Inner copper layer 28
    "In29.Cu", // Inner copper layer 29
    "In30.Cu", // Inner copper layer 30
    "F.Cu", // Front copper layer
    "B.Cu", // Back copper layer
    "B.Adhes", // Back adhesive layer
    "F.Adhes", // Front adhesive layer
    "B.Paste", // Back solder paste layer
    "F.Paste", // Front solder paste layer
    "B.SilkS", // Back silk screen layer
    "F.SilkS", // Front silk screen layer
    "B.Mask", // Back solder mask layer
    "F.Mask", // Front solder mask layer
    "Dwgs.User", // User drawing layer
    "Cmts.User", // User comment layer
    "Eco1.User", // User engineering change order layer 1
    "Eco2.User", // User engineering change order layer 2
    "Edge.Cuts", // Board outline layer
    "Margin", // Board outline layer
    "F.CrtYd", // Footprint front courtyard layer
    "B.CrtYd", // Footprint back courtyard layer
    "F.Fab", // Footprint front fabrication layer
    "B.Fab", // Footprint back fabrication layer
    "User.1", // User definable layer 1
    "User.2", // User definable layer 2
    "User.3", // User definable layer 3
    "User.4", // User definable layer 4
    "User.5", // User definable layer 5
    "User.6", // User definable layer 6
    "User.7", // User definable layer 7
    "User.8", // User definable layer 8
    "User.9", // User definable layer 9
    // QUESTION: Is these valid layers to include here?
    "*.Cu", // All copper layers
    "*.Mask", // All mask layers
    "*.Paste", // All paste layers
    "drill",
];
const kicadTemplate = {
    kicad_pcb: {
        version: "20171130",
        general: {
            thickness: 1.6,
            drawings: 16,
            tracks: 0,
            zones: 0,
            modules: 6,
            nets: 9,
        },
        layers: [
            { index: "0", name: "F.Cu", layer_type: "signal", hide: false },
            { index: "1", name: "In1.Cu", layer_type: "signal", hide: false },
            { index: "2", name: "In2.Cu", layer_type: "signal", hide: false },
            { index: "3", name: "In3.Cu", layer_type: "signal", hide: false },
            { index: "4", name: "In4.Cu", layer_type: "signal", hide: false },
            { index: "5", name: "In5.Cu", layer_type: "signal", hide: false },
            { index: "6", name: "In6.Cu", layer_type: "signal", hide: false },
            { index: "31", name: "B.Cu", layer_type: "signal", hide: false },
            { index: "32", name: "B.Adhes", layer_type: "user", hide: false },
            { index: "33", name: "F.Adhes", layer_type: "user", hide: false },
            { index: "34", name: "B.Paste", layer_type: "user", hide: false },
            { index: "35", name: "F.Paste", layer_type: "user", hide: false },
            { index: "36", name: "B.SilkS", layer_type: "user", hide: false },
            { index: "37", name: "F.SilkS", layer_type: "user", hide: false },
            { index: "38", name: "B.Mask", layer_type: "user", hide: false },
            { index: "39", name: "F.Mask", layer_type: "user", hide: false },
            { index: "40", name: "Dwgs.User", layer_type: "user", hide: false },
            { index: "41", name: "Cmts.User", layer_type: "user", hide: false },
            { index: "42", name: "Eco1.User", layer_type: "user", hide: false },
            { index: "43", name: "Eco2.User", layer_type: "user", hide: false },
            { index: "44", name: "Edge.Cuts", layer_type: "user", hide: false },
            { index: "45", name: "Margin", layer_type: "user", hide: false },
            { index: "46", name: "B.CrtYd", layer_type: "user", hide: false },
            { index: "47", name: "F.CrtYd", layer_type: "user", hide: false },
            { index: "48", name: "B.Fab", layer_type: "user", hide: false },
            { index: "49", name: "F.Fab", layer_type: "user", hide: false },
        ],
        setup: {
            last_trace_width: 0.25,
            trace_clearance: 0.2,
            zone_clearance: 0.508,
            zone_45_only: false,
            trace_min: 0.2,
            via_size: 0.8,
            via_drill: 0.4,
            via_min_size: 0.4,
            via_min_drill: 0.3,
            uvia_size: 0.3,
            uvia_drill: 0.1,
            uvias_allowed: false,
            uvia_min_size: 0.2,
            uvia_min_drill: 0.1,
            edge_width: 0.05,
            segment_width: 0.2,
            pcb_text_width: 0.3,
            pcb_text_size: [1.5, 1.5],
            mod_edge_width: 0.12,
            mod_text_size: [1, 1],
            mod_text_width: 0.15,
            pad_size: [1.7, 3.4],
            pad_drill: 1,
            pad_to_mask_clearance: 0,
            aux_axis_origin: [136, 99],
            grid_origin: [136, 99],
            visible_elements: "FFFFFF7F",
        },
    },
};
// | {[key:string]: IKicadModuleSubtypes}
const simpleDeepCopy = (srcObj) => {
    return JSON.parse(JSON.stringify(srcObj));
};
export const createKicadHeader = () => {
    return simpleDeepCopy(kicadTemplate);
};
export const createModuleTemplate = () => {
    return simpleDeepCopy(moduleTemplate);
};
//# sourceMappingURL=KicadTypes.js.map